import { AzFunctionRuntimeStatus } from "../enums/az-function-runtime-status";

export class TiffProcessingStatus {
  status: AzFunctionRuntimeStatus;
  error: boolean;
  message?: string;
  detail?: string;

  constructor(
    status: AzFunctionRuntimeStatus,
    error: boolean,
    message?: string,
    detail?: string
  ) {
    this.status = status;
    this.error = error;
    this.message = message;
    this.detail = detail;
  }
}
